import { CORE_PLUGIN } from "@/core"
import type { Plugin } from "@/plugins"
import { injectable, instanceCachingFactory, registry, singleton } from "tsyringe"
import CommentAppend from "./components/CommentAppend.vue"
import CommentContent from "./components/CommentContent.vue"
import CommentItem from "./components/CommentItem.vue"
import CommentReply from "./components/CommentReply.vue"
import { defineStore } from "pinia"

export const CommentPageOptionsInjectKey = "CommentPageOptionsInjectKey"
export const commentStore = defineStore("commentStore", {
  state: () => ({
    showFlag: '',
  }),
})
@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<unknown, unknown>>((c) => c.resolve(CommentPlugin))
  }
])
@injectable()
export class CommentPlugin implements Plugin<unknown, unknown> {
  id: string | symbol = ''
  options: unknown
  service: unknown

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    app.component("FlashbaseCommentAppend", CommentAppend)
    app.component("FlashbaseCommentContent", CommentContent)
    app.component("FlashbaseCommentItem", CommentItem)
    app.component("FlashbaseCommentReply", CommentReply)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialized(app: App<Element>): void { }
}
